export function renderAbout(): string {
  return `
    <h1 class="section-title" style="margin-top:0">关于尚诺艾</h1>
    <p class="section-sub">
      SANOI — 聚焦古典音乐与古典名画的数字体验。本站为品牌与内容总门户，小程序承担深度互动与商业闭环。
    </p>
    <ul class="game-list">
      <li>
        <h3>微信小程序</h3>
        <p>在首页与详情页将提供小程序码与「继续到微信」说明；账号与会员体系后期打通。</p>
      </li>
      <li>
        <h3>合作与版权</h3>
        <p>商务联系、媒体素材、名画图源与曲目授权说明（上线前于页脚提供完整法律文本）。</p>
      </li>
    </ul>
  `;
}
